export default {
  核心技术: '核心技术',
  云端建筑企业: '云端建筑企业',
  szls提示1: '云端完整构筑整个企业,实现数字世界与现实世界互联',
  开启您的数字世界: '开启您的数字世界',
  实景克隆工具: '实景克隆工具',
  szls提示2: '实景克隆多维展示,快速构建数字工厂的3D可视化工具',
  数字贸易升级: '数字贸易升级',
  szls提示3: '助力企业数字化转型升级,增效降本管理现实世界',
  立即构建您的云展厅: '立即构建您的云展厅',
  空间重建: '空间重建',
  空间互动: '空间互动',
  空间展示: '空间展示',
  szls提示4: '孪生体,云端观看企业实景',
  szls提示5: '720度全方位看实力、巡产线、看产品',
  构建您的数字孪生场景: '构建您的数字孪生场景',
  展实力3D展厅: '展实力3D展厅',
  巡产线3D工厂: '巡产线3D工厂',
  看产品3D产品: '看产品3D产品',
  案例分享: '案例分享',
  了解更多: '了解更多',
  szls提示6: '24小时漫游云展厅',
  打破时空限制: '打破时空限制',
  szls提示7: '365天不停歇展示',
  实现24小时云上贸易: '实现24小时云上贸易',
  szls提示8: '720度全方位看实力,巡产线,看产品',
  szls提示9: '更深入了解企业真正实力',
  szls提示10: '增加客户信赖,加速商机转化',
  szls提示11: '全方位打造企业数字化展示系统',
  szls提示12: '助力企业营销自动化',
  szls提示13: '降低人员成本,建立高效拓客模式',
  打破二维格局: '打破二维格局',
  营销自动化: '营销自动化',
}
